import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import FileInputResult from '../../../Shared/FileInputResult/FileInputResult'
import { fileColName, InvalidCellReason, OwnershipTransferStep } from '../Constant/Constant'
import { setCurrentStep } from '../OwnershipTransferSlice'


const BulkRequestErrorPage = (props) => {
  function uploadNewFile() {
    props.setCurrentStep(OwnershipTransferStep.UploadFile)
  }

  return (
    <FileInputResult
      invalidLineFile={props.data.invalidLineList}
      fileColName={fileColName}
      invalidCellReason={InvalidCellReason}
      uploadNewFile={uploadNewFile}
      downloadCSV={true}
      fileName='העברת בעלות מנויים שגויים' />
  )
}

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkRequestErrorPage);
